export default "__VITE_ASSET__77e4a953__"